import { useNavigateTo, useRouteParams } from "@neru/base/hooks";
import { componentLoader } from "@neru/base/utils";
import { Spinner } from "@neru/ui";
import { lazy, Suspense, useEffect } from "react";

import { ProductDetails } from "./ProductDetails/ProductDetails";

const Documentation = lazy(() =>
  componentLoader(() => import("./Documentation/Documentation")),
);
const Releases = lazy(() =>
  componentLoader(() => import("./Releases/Releases")),
);

export interface DeployProductData {
  instanceName: string;
  regionId: string;
}

interface ProductProps {
  documentation?: boolean;
  releases?: boolean;
}

export const Product = ({ documentation, releases }: ProductProps) => {
  const navigateTo = useNavigateTo();
  const { productId } = useRouteParams("productId");

  useEffect(() => {
    if (!productId) {
      navigateTo("/");
    }
  }, [productId, navigateTo]);

  if (!productId) {
    return <Spinner />;
  }

  if (documentation) {
    return (
      <Suspense fallback={<Spinner />}>
        <Documentation productId={productId} />
      </Suspense>
    );
  }

  if (releases) {
    return (
      <Suspense fallback={<Spinner />}>
        <Releases productId={productId} />
      </Suspense>
    );
  }

  return <ProductDetails productId={productId} />;
};

export default Product;
